import { render, staticRenderFns } from "./question5.vue?vue&type=template&id=4e815409&"
import script from "./question5.vue?vue&type=script&lang=js&"
export * from "./question5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports